module.exports = __webpack_public_path__ + "img/5.26699440.svg";